import React, { useContext } from "react";
import environment from "../../../../../RelayEnvironment";
import { graphql, QueryRenderer } from "react-relay";
import ItemSelection from "../ItemSelection";
import { GreenMachineContext } from "../GreenMachineContext";

import "./SelectGameType.css";

const STAGE_NUMBER = 1;

const GET_GAME_TYPES_FOR_SPORT = graphql`
  query SelectGameTypeQuery($sportId: ID!) {
    activeGameTypesForSport(sportId: $sportId) {
      id
      name
      gametypelineupsetSet {
        edges {
          node {
            lineupSet {
              lineuprosterslotSet {
                edges {
                  node {
                    id
                    rosterSlot {
                      name
                    }
                    order
                    amount
                    selectable
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default function SelectGameType() {
  const {
    selectedSportID,
    selectedGameTypeID,
    setSelectedGameTypeID,
    setGameTypeLineupSet,
    currentStage,
    updateCurrentStage,
  } = useContext(GreenMachineContext);

  function handleGameTypeSelect(e, gameType) {
    e.preventDefault();

    setGameTypeLineupSet(
      gameType.gametypelineupsetSet.edges[0].node.lineupSet.lineuprosterslotSet
        .edges
    );

    setSelectedGameTypeID(gameType.id);

    updateCurrentStage();
  }

  if (currentStage < STAGE_NUMBER) {
    return null;
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_GAME_TYPES_FOR_SPORT}
      variables={{
        sportId: selectedSportID,
      }}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return <></>;
        }

        if (currentStage > 1) {
          return null;
        }

        return (
          <div className="gm-select-game-type-container">
            <ItemSelection
              items={props.activeGameTypesForSport}
              onClick={handleGameTypeSelect}
            />
          </div>
        );
      }}
    />
  );
}
